import {StyleSheet} from 'react-native';

export const styles =  StyleSheet.create({
    page: {
        marginTop: 48
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700'
    },

    subTitle: {
        fontSize: 28,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700'
    },

    rowBoxes: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 12,
        flex: 1,
    },

    colBoxes: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        justifyContent: 'center',
        alignItems: 'center'
    },

    yellowBox: {
        backgroundColor: "#FFC646",
        borderRadius: 12,
        paddingLeft: 18,
        width: 220,
    },

    boxTitle: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        width: '95%'
    },

    boxSubTitle: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        marginTop: 15
    }
});